import { req, get, post } from '@/plugins/axios'
import type { res } from './login'

// 全部附加项列表
interface ALD {
  productType: number | string
}
export const getAdtList = (data: ALD): Promise<res> =>
  req('/settlement/customer/addition/getAdditionList', data)

// 后台配置附加项模板
export const getAdtTmpl = (): Promise<res> =>
  get('/customer/additional/getList')

// 附加项辅料
export const getIngredients = (): Promise<res> =>
  get('/order/customer/shop/ingredients/customer/list')

// 获取次转正附加项
export const getBadAddition = (data: any): Promise<res> =>
  post('/order/regularization/getBadAddition', data)
